export default function MembershipPlanColumn(props) {
    return (
        <div {...props} className="membership-plan-column">
            <div className="membership-plan-title">{props.planname}</div>
            <div className="membership-plan-value capitalize">: <p>{props.planvalue}</p></div>
        </div>
    )
}